export const media = {
    isUserGestureRequired: () => {
        const audioCtx = new AudioContext();

        if (audioCtx.state === "suspended") {
            // Audio playback is suspended, likely requires user gesture to resume.
            // Attach an event listener (e.g., click) to resume.
            return true
        } else {
            return false
        }
    }
}